require('./bootstrap');

// Import modules...
import Vue from 'vue';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Kuala_Lumpur')

import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue';
import PortalVue from 'portal-vue';

import vuetify from './Plugins/vuetify'
import store from "./store"
import router from './router'
import './Plugins/vuetify-mask'
import Vuebar from "vuebar"
import VueSkycons from "vue-skycons"
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import VueHtmlToPaper from 'vue-html-to-paper'
const options = {
   name: '_blank',
   specs: [
     'fullscreen=yes',
     'titlebar=yes',
     'scrollbars=yes'
   ],
   styles: [
      'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css',
      'https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css',
      '/css/app.css'
   ]
}
import JsonExcel from "vue-json-excel"
import VJsf from '@koumoul/vjsf'


Vue.mixin({ methods: { route } });
Vue.use(InertiaPlugin);
Vue.use(PortalVue);

Vue.component('VJsf', VJsf)
Vue.component("downloadExcel", JsonExcel)
Vue.use(VueHtmlToPaper, options)
Vue.use(TiptapVuetifyPlugin, {
    // the next line is important! You need to provide the Vuetify Object to this place.
    vuetify, // same as "vuetify: vuetify"
    // optional, default to 'md' (default vuetify icons before v2.0.0)
    iconsGroup: 'mdi'
 })
Vue.use(VueMoment, { moment })
Vue.use(VueSkycons, {
    color: "#1e88e5",
})
Vue.use(Vuebar)

const app = document.getElementById('app');

new Vue({
    vuetify,
    store,
    router,
    render: (h) =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: (name) => require(`./Pages/${name}`).default,
            },
        }),
}).$mount(app);
